module.exports = __webpack_public_path__ + "static/media/tools-slider-img3.58d24c07.png";